import BuilderVM from './builder-vm';
import WizardPage from 'libs/wizard-page';
import WizardStepNav from 'libs/wizard-step-nav';
var that = {};
var stepProgress;
var currentPageIdx = 0;
var PAGES = [];
var Wiz = {};

//Specific page objects
Wiz.TemplateSelectionPage = function() { this.init.apply(this, arguments); };
Wiz.TemplateSelectionPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'cww-template-selection',
  name: 'Select Template',
  icon: 'kf-import-course',

  validate: function(viewModel) {
    return viewModel.validate(this.id, false);
  }
});

Wiz.GeneralInfoPage = function() { this.init.apply(this, arguments); };
Wiz.GeneralInfoPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'cww-general-info',
  name: Kadenze.I18n.t('wizard.general_info'),
  icon: 'kf-info',

  validate: function(viewModel) {
    return viewModel.validate(this.id, false);
  }
});

Wiz.FormBuilderPage = function() { this.init.apply(this, arguments); };
Wiz.FormBuilderPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'cww-form-builder',
  name: 'Form Submission',
  icon: 'kf-quiz',

  validate: function(viewModel) {
    return viewModel.validate(this.id, true);
  }
});

Wiz.AssociatedAssetsPage = function() { this.init.apply(this, arguments); };
Wiz.AssociatedAssetsPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'cww-assets',
  name: Kadenze.I18n.t('wizard.associated_assets'),
  icon: 'kf-upload',

  validate: function(viewModel) {
    return viewModel.validate(this.id, false);
  }
});

Wiz.ReviewPage = function() { this.init.apply(this, arguments); };
Wiz.ReviewPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'cww-review',
  name: Kadenze.I18n.t('wizard.review'),
  icon: 'kf-checkmark',

  validate: function(viewModel) {
    return true;
  }
});
/*--------------------------------------------PAGE NAV FUNCTIONS----------------------------------------------------*/
var initCourseworkWizard = function() {
  PAGES = [
    new Wiz.TemplateSelectionPage(),
    new Wiz.GeneralInfoPage(),
    new Wiz.FormBuilderPage(),
    new Wiz.AssociatedAssetsPage(),
    new Wiz.ReviewPage()
  ];

  var data = $('#coursework_json').val();
  var $el = $('#wizard-container');
  var validationOptions = {
    insertMessages: true,
    errorsAsTitle: true,
    decorateInputElement: true,
    parseInputAttributes: true,
    messagesOnModified: true,
    errorElementClass: 'error',
    errorMessageClass: 'error_message',
    decorateElementOnModified: true,
    decorateElement: true,
    grouping: { deep: true, observable: true, live: true }
  };

  that.viewModel = new BuilderVM(data, self);

  if (that.viewModel.selectTemplate() == false) {
    var stepIndex = _.findIndex(PAGES, function(step) { return step.id == 'cww-template-selection'; });
    if (stepIndex > -1)
      PAGES.splice(stepIndex, 1); //Remove TemplateSelectionPage
  }
  Wiz.FormBuilderPage.prototype.name = that.viewModel.coursework().presentation_name() + ' Builder';

  //modify an existing templateEngine to work with string templates
  var createStringTemplateEngine = function(templateEngine, templates) {
    templateEngine.makeTemplateSource = function(template) {
      return new ko.templateSources.stringTemplate(template, templates);
    };
    return templateEngine;
  };

    //make this new template engine our default engine
  ko.setTemplateEngine(createStringTemplateEngine(new ko.nativeTemplateEngine(), that.viewModel.templates));

  ko.applyBindingsWithValidation(that.viewModel, $el[0], validationOptions);


  var stepObj = {
    numVisible: 1,
    pages: PAGES,
    breakpoints: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  };
    //Init progress bar AFTER ko binds with the DOM so it can get the accurate step count
  stepProgress = new WizardStepNav($('#js-wizardNav'), self, stepObj);

  $('.js-cw-next').bind('click', $.proxy(onNextClick, that)); // set next step btn
  $('.js-cw-prev').bind('click', $.proxy(onPreviousClick, that)); // set next step btn

  showPageByIndex(0); // start the type select page;
};

var showPageByIndex = function(index) {
  //Persist Templated Surveys before moving beyond step 1
  if (that.viewModel.selectTemplate() && index >= 1 && !that.viewModel.coursework().id()) {
    var response = that.viewModel.save($('#wizard-container'));
    response.success(function () {
      showPage(PAGES[index]);
    });
    response.error(function (xhr, textStatus, errorThrown) {
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'Please select a template before moving forward.' }));
    });
  } else {
    showPage(PAGES[index]);
  }
};

var showPage = function(pageObj) {
  var $page = $('#' + pageObj.id);
  currentPageIdx = PAGES.indexOf(pageObj);

  $('.coursework-new__step').stop(true, true).hide(); // hide all subpages
  $page.stop(true, true).fadeIn(); // show subpage by pageID

  stepProgress.setActiveStepByIndex(currentPageIdx);
  that.viewModel.initStepUI(pageObj.id);
};

var onNextClick = function(e) {
  hideCurrentErrors();
  var curPage = PAGES[currentPageIdx];
  var errors = curPage.validate(that.viewModel);
  if (errors.length == 0) {
    if (!justSaved()) {
      var request = that.viewModel.save($('#' + curPage.id));
      request.success(function(data, textStatus, xhr) {
        nextPage();
      }).error(function(xhr, textStatus, errorThrown) {
        curPage.errors = xhr.responseJSON.errors;
        showCurrentPageErrors();
      });
    } else {
      nextPage();
    }
  }
  else {
    curPage.errors = ['This page has some invalid fields. Please fix them before proceeding.'];
    showCurrentPageErrors();
  }
};

var onPreviousClick = function(e) {
  previousPage();
};

var isFirstPage = function() {
  return (currentPageIdx === 0);
};

var isLastPage = function() {
  return (currentPageIdx + 1) === PAGES.length;
};

var nextPage = function() {
  if (!isLastPage()) {
    currentPageIdx++;
    while(!PAGES[currentPageIdx].isEnabled(that.viewModel)) {
      currentPageIdx++;
    }
    showPageByIndex(currentPageIdx);
  }
};

var previousPage = function() {
  if (!isFirstPage()) {
    currentPageIdx--;
    while(!PAGES[currentPageIdx].isEnabled(that.viewModel)) {
      currentPageIdx--;
    }
    showPageByIndex(currentPageIdx);
  }
};

var showCurrentPageErrors = function() {
  var curPage = PAGES[currentPageIdx];
  var $errContainer = $('.instructor-error-list');

  var noticeOptions = {
    parentObject: $errContainer.parent(),
    message: curPage.errors
  };

  that.errorsInstance = new Kadenze.Notice.error(noticeOptions);
};

var hideCurrentErrors = function() {
  var curPage = PAGES[currentPageIdx];
  var $errContainer = $('.instructor-error-list');

  if (that.errorsInstance) that.errorsInstance.destroy();

  if ($errContainer.length > 0) {
    Kadenze.UIUtil.hideErrors($errContainer);
  }
};

var justSaved = function() {
  return that.viewModel.savedAt() ? ((new Date() - that.viewModel.savedAt()) < 20000) : false;
};
  /*----------------------------------------------INIT FUNCTIONS----------------------------------------------------*/
var self =  {
  init: function() {
    console.log('Initializing FormWizard');
    initCourseworkWizard();
  },
  showPageByIndex: function(index) {
    showPageByIndex(index);
  },
  getProgressInstance: function() {
    return stepProgress;
  }
};

export default self;


